import * as types from './actionTypes'

export const deleteExportTemplate = (id) => ({
    type: types.EXPORT_TEMPLATE_DELETE,
    id
})

export const deleteExportTemplateSuccess = () => ({
    type: types.EXPORT_TEMPLATE_DELETE_SUCCESS
})

export const deleteExportTemplateFailed = () => ({
    type: types.EXPORT_TEMPLATE_DELETE_FAILED
})

export const exportData = (template, documents) => ({
    type: types.EXPORT_DATA,
    template,
    documents
})

export const exportDataSuccess = () => ({
    type: types.EXPORT_DATA_SUCCESS
})

export const exportDataFailed = () => ({
    type: types.EXPORT_DATA_FAILED
})

export const setExportDataTemplatesOrder = (entity, order) => ({
    type: types.SET_EXPORT_DATA_TEMPLATES_ORDER,
    entity,
    order
})
